<div class="row top_search sticky-nav" style="width: 95%">
     
  <div class="col-md-9">


   <input class="stakeholder_search"
                 type="text"
                 
                 placeholder="Search for Stakeholders" [(ngModel)]="searchvalue" (ngModelChange)="searchStakeholder()"
             />


 
  </div>
  <div class="col-md-3" >
    
  </div>
</div>

<div *ngFor="let stakeholder of filteredstakeholders; let i = index">
<div class="stakeholder_search-reuslts" style="cursor:pointer" (click)="selectStakeholder(stakeholder)">
<div class="name d-inline-block"><em class="ti-user ml-2"></em> <h4 class="stakeholder_name d-inline-block">{{stakeholder.Title? stakeholder.Title.TitleName: ""}} {{stakeholder.Fullname}}</h4></div>
<div class="phone_number d-inline-block"><em class="ti-mobile"></em> {{fullPhoneEmail(stakeholder,'phone')}}</div>
<button mat-icon-button (click)="$event.stopImmediatePropagation()" [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
  <mat-icon>more_vert</mat-icon>
</button>
<mat-menu #menu="matMenu">
  <button mat-menu-item>
    <mat-icon>dialpad</mat-icon>
    <span>Edit</span>
  </button>
  <button mat-menu-item>
    <mat-icon>dialpad</mat-icon>
    <span>Interactions</span>
  </button>
  <button mat-menu-item disabled>
    <mat-icon>voicemail</mat-icon>
    <span>Complaints</span>
  </button>
  <button mat-menu-item>
    <mat-icon>notifications_off</mat-icon>
    <span>Task</span>
  </button>
  <button mat-menu-item>
    <mat-icon>notifications_off</mat-icon>
    <span>Correspondence</span>
  </button>
</mat-menu>

<div class="search_info">
  <h5>
    <span class="title"> <em class="ti-calendar"></em> Day/Month</span>
    <span class="answer">{{stakeholder.DOBShort}}</span>
  </h5>
  <h5>
    <span class="title"><em class="ti-flag-alt-2"></em> Party</span>
    <span class="answer">{{ stakeholder.PoliticalParty? stakeholder.PoliticalParty.PoliticalPartyName: ''}} </span>
  </h5>
  <h5>
    <span class="title"><em class="ti-target"></em> Club</span>
    <span class="answer">Manchester United</span>
  </h5>
  <h5>
    <span class="title"><em class="ti-email"></em> Email</span>
    <span class="answer">{{fullPhoneEmail(stakeholder,'email')}}</span>
  </h5>
</div>
<mat-accordion>

              

 

  <mat-expansion-panel class="section">
    <mat-expansion-panel-header style="margin-bottom: 5px;" (click)="$event.stopImmediatePropagation()">
      <mat-panel-title  style="padding:3rem 0; color: green;">
        <span class=" mr-2"  > <em class="ti-layers"></em> </span>Details
      </mat-panel-title>
      <mat-panel-description>
       
      </mat-panel-description>
    </mat-expansion-panel-header>

    <mat-form-field class="contain mr-4" style="width:40%">
      <mat-label>First name</mat-label>
      <input matInput class="field">
    </mat-form-field>

    <mat-form-field class="contain mr-4" style="width:40%">
      <mat-label>Age</mat-label>
      <input matInput type="number" min="1" class="field">
    </mat-form-field>

    <span class="mr-4"><em class="ti-close mr-1" style="color:#000; font-weight: bold; cursor:pointer"></em> </span>
    <input type="checkbox" name="" id="">

  </mat-expansion-panel>

 
</mat-accordion>
</div>
</div>